// would be called from the component to dispatch the action
export const GET_PROVIDER_DATA = "GET_PROVIDER_DATA";
export const GET_PROVIDER_DATA_BY_NAME = "GET_PROVIDER_DATA_BY_NAME";
export const GET_PROVIDER_CATEGORIES = "GET_PROVIDER_CATEGORIES";
export const GET_PROVIDER_API_CALL_COUNT_BY_CLIENT =
  "GET_PROVIDER_API_CALL_COUNT_BY_CLIENT";
export const GET_PROVIDER_NAME_PREDICTION = "GET_PROVIDER_NAME_PREDICTION";
export const GET_CPT_CODE_SUGGESTION = "GET_CPT_CODE_SUGGESTION";
export const GET_PROVIDER_SEARCH_DATA_BY_CPT =
  "GET_PROVIDER_SEARCH_DATA_BY_CPT";
export const GET_PROVIDER_SEARCH_DATA_BY_FACILITY =
  "GET_PROVIDER_SEARCH_DATA_BY_FACILITY";
const ACTION_LOADER = "ACTION_LOADER";
const ACTION_AI_LOADER = "ACTION_AI_LOADER";
const INPUT_ACTION_LOADER = "INPUT_ACTION_LOADER";
export const SEARCH_TEXT = "SEARCH_TEXT";
export const GET_COMMENT = "GET_COMMENT";
export const ADD_COMMENT = "ADD_COMMENT";
export const ADD_CLAIM = "ADD_CLAIM";
export const ADD_PROVIDER_LIKE = "ADD_PROVIDER_LIKE";
export const GET_USER_ACTIVITY = "GET_USER_ACTIVITY";
export const GET_USERS_ACTIVITY = "GET_USERS_ACTIVITY";
export const GET_PROVIDER_DATA_BY_NPI = "GET_PROVIDER_DATA_BY_NPI";
export const GET_AI_SEARCH_RESULT = "GET_AI_SEARCH_RESULT";

// interal action names which would be used by the saga effects to update the data

const SET_PROVIDER_DATA = "SET_PROVIDER_DATA";
const SET_PROVIDER_CATEGORIES = "SET_PROVIDER_CATEGORIES";
const SET_PROVIDER_SEARCH_BY_SPECIALTY = "SET_PROVIDER_SEARCH_BY_SPECIALTY";
const SET_PROVIDER_SEARCH_QUERY_BY_PROVIDER =
  "SET_PROVIDER_SEARCH_QUERY_BY_PROVIDER";
const SET_PROVIDER_SEARCH_QUERY_BY_CPT = "SET_PROVIDER_SEARCH_QUERY_BY_CPT";
const SET_PROVIDER_SEARCH_QUERY_BY_FACILITY =
  "SET_PROVIDER_SEARCH_QUERY_BY_FACILITY";
const SET_PROVIDER_NAME_PREDICTION = "SET_PROVIDER_NAME_PREDICTION";
const SET_CPT_CODE_SUGGESTION = "SET_CPT_CODE_SUGGESTION";
const SET_PROVIDER_API_CALL_COUNT_BY_CLIENT =
  "SET_PROVIDER_API_CALL_COUNT_BY_CLIENT";
const SET_SEARCH_DISTANCE = "SET_SEARCH_DISTANCE";
const SET_PROVIDER_COMMENT = "SET_PROVIDER_COMMENT";
const SET_ADD_PROVIDER_COMMENT = "SET_ADD_PROVIDER_COMMENT";
const SET_ADD_PROVIDER_LIKE_FEEDBACK = "SET_ADD_PROVIDER_LIKE_FEEDBACK";
const SET_USERS_ACTIVITY = "SET_USERS_ACTIVITY";
const SET_ADD_CLAIM = "SET_ADD_CLAIM";
const SET_AI_SEARCH_RESULT = "SET_AI_SEARCH_RESULT";

const SET_MAGIC_WAND_FILTER = "SET_MAGIC_WAND_FILTER";

// action get called from the component to get the data via api call
export const getProviderComment = (payload) => ({
  type: GET_COMMENT,
  payload,
});

// action get called when user hits the submit button to add the comment for the provider
export const addProviderComment = (payload) => ({
  type: ADD_COMMENT,
  payload,
});

// action get called once the addComment api is done successfully to store the response success
export const setAddProviderComment = (payload) => ({
  type: SET_ADD_PROVIDER_COMMENT,
  payload,
});

// action get called when user hits the generate button to add the claim number for the provider
export const addProviderClaim = (payload) => ({
  type: ADD_CLAIM,
  payload,
});

// action get called once the  api is done successfully to store the response success
export const setAddProviderClaim = (payload) => ({
  type: SET_ADD_CLAIM,
  payload,
});

// action get called once the getComment api is done successfully to store the response of all the comments for the specific provider where we pass npi
export const setProviderComment = (payload) => ({
  type: SET_PROVIDER_COMMENT,
  payload,
});

// action get called from the component to get the Users Activity
export const getUsersActivity = () => ({
  type: GET_USERS_ACTIVITY,
});

// action get called from the component to get the Users Activity
export const getUserActivity = () => ({
  type: GET_USER_ACTIVITY,
});

export const getProviderDataByNPI = (payload) => ({
  type: GET_PROVIDER_DATA_BY_NPI,
  payload,
});

//action to set the user activity

export const setUserActivity = (payload) => ({
  type: SET_USERS_ACTIVITY,
  payload,
});

// action get called from the component to add the like feedback via api call
export const addLikefeedback = (payload) => ({
  type: ADD_PROVIDER_LIKE,
  payload,
});

export const setAddLikeFeedback = (payload) => ({
  type: SET_ADD_PROVIDER_LIKE_FEEDBACK,
  payload,
});

export const setMagicWandFilter = (payload) => ({
  type: SET_MAGIC_WAND_FILTER,
  payload,
});

export const getProviderSearchData = (payload) => ({
  type: GET_PROVIDER_DATA,
  payload,
});

export const getProviderSearchDataByName = (payload) => ({
  type: GET_PROVIDER_DATA_BY_NAME,
  payload,
});

export const getProviderCategoryData = () => ({
  type: GET_PROVIDER_CATEGORIES,
});

export const setProviderSearchData = (providerSearchData) => ({
  type: SET_PROVIDER_DATA,
  providerSearchData,
});

export const setProviderCategoryData = (providerCategory) => ({
  type: SET_PROVIDER_CATEGORIES,
  providerCategory,
});
export const setLoaderState = (loadingState) => ({
  type: ACTION_LOADER,
  loadingState,
});
export const setInputLoaderState = (loadingState) => ({
  type: INPUT_ACTION_LOADER,
  loadingState,
});
export const setProviderSearchType = (payload) => ({
  type: SEARCH_TEXT,
  payload,
});
export const setAILoaderState = (loadingState) => ({
  type: ACTION_AI_LOADER,
  loadingState,
});
export const setProviderSearchQueryBySpecialty = (
  providerSearchQueryBySpecialty
) => ({
  type: SET_PROVIDER_SEARCH_BY_SPECIALTY,
  providerSearchQueryBySpecialty,
});
export const setProviderSearchQueryByProvider = (
  providerSearchQueryByProvider
) => ({
  type: SET_PROVIDER_SEARCH_QUERY_BY_PROVIDER,
  providerSearchQueryByProvider,
});

//CPT Code
export const setProviderSearchQueryByCPT = (providerSearchQueryByCPT) => ({
  type: SET_PROVIDER_SEARCH_QUERY_BY_CPT,
  providerSearchQueryByCPT,
});

export const setProviderSearchQueryByFacility = (
  providerSearchQueryByFacility
) => ({
  type: SET_PROVIDER_SEARCH_QUERY_BY_FACILITY,
  providerSearchQueryByFacility,
});
export const getProviderSearchDataByFacility = (payload) => ({
  type: GET_PROVIDER_SEARCH_DATA_BY_FACILITY,
  payload,
});

export const getProviderSearchDataByCpt = (payload) => ({
  type: GET_PROVIDER_SEARCH_DATA_BY_CPT,
  payload,
});

export const getCptCodeSuggestion = (payload) => ({
  type: GET_CPT_CODE_SUGGESTION,
  payload,
});

export const setCptCodeSuggestion = (payload) => ({
  type: SET_CPT_CODE_SUGGESTION,
  payload,
});

export const getProviderNamePrediction = (payload) => ({
  type: GET_PROVIDER_NAME_PREDICTION,
  payload,
});

export const setProviderNamePrediction = (payload) => ({
  type: SET_PROVIDER_NAME_PREDICTION,
  payload,
});

export const getProviderApiCallCountByClient = (ClientId) => ({
  type: GET_PROVIDER_API_CALL_COUNT_BY_CLIENT,
  ClientId,
});

export const setProviderApiCallCountByClient = (
  providerApiCallCountByClient
) => ({
  type: SET_PROVIDER_API_CALL_COUNT_BY_CLIENT,
  providerApiCallCountByClient,
});

export const setProviderSearchDistance = (payload) => ({
  type: SET_SEARCH_DISTANCE,
  payload,
});

export const getAiSearchResult = (payload) => ({
  type: GET_AI_SEARCH_RESULT,
  payload,
});

export const setAiSearchResult = (payload) => ({
  type: SET_AI_SEARCH_RESULT,
  payload,
});

const initialState = {
  providerSearchData: {},
  providerCategory: [],
  isLoading: false,
  inputLoading: false,
  providerSearchQueryBySpecialty: {},
  providerSearchQueryByProvider: {},
  providerSearchQueryByCPT: {},
  providerSearchQueryByFacility: {},
  cptCodeSuggestion: [],
  predictedProviderNames: [],
  providerSearchType: "address",
  magicWandFilterValue: false,
  providerSearchDistance: 10,
  providerComment: {},
  addedComment: {},
  addedClaim: {},
  addedLikeFeedback: {},
  usersActivity: [],
  backgroundResearchData: {},
  isGettingData: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PROVIDER_DATA:
      const { providerSearchData } = action;
      return { ...state, providerSearchData: providerSearchData };
    case SET_PROVIDER_CATEGORIES:
      const { providerCategory } = action;
      return { ...state, providerCategory: providerCategory };
    case ACTION_LOADER:
      return { ...state, isLoading: action.loadingState };
    case ACTION_AI_LOADER:
      return { ...state, isGettingData: action.loadingState };
    case INPUT_ACTION_LOADER:
      return { ...state, inputLoading: action.loadingState };
    case SEARCH_TEXT:
      return { ...state, providerSearchType: action.payload };
    case SET_PROVIDER_SEARCH_BY_SPECIALTY:
      const { providerSearchQueryBySpecialty } = action;
      return {
        ...state,
        providerSearchQueryBySpecialty: {
          searchText: providerSearchQueryBySpecialty?.searchText,
          specialty: providerSearchQueryBySpecialty?.specialty,
          travelDistance: providerSearchQueryBySpecialty?.travelDistance,
        },
      };
    case SET_MAGIC_WAND_FILTER:
      return { ...state, magicWandFilterValue: action.payload };

    case SET_PROVIDER_SEARCH_QUERY_BY_CPT:
      const { providerSearchQueryByCPT } = action;
      return {
        ...state,
        providerSearchQueryByCPT: {
          state: providerSearchQueryByCPT?.state,
          bodyPart: providerSearchQueryByCPT?.bodyPart,
          travelDistance: providerSearchQueryByCPT?.travelDistance,
          treatmentType: providerSearchQueryByCPT?.treatmentType,
        },
      };
    case SET_PROVIDER_SEARCH_QUERY_BY_FACILITY:
      const { providerSearchQueryByFacility } = action;
      return {
        ...state,
        providerSearchQueryByFacility: {
          searchText: providerSearchQueryByFacility.searchText,
          facilityTypeName: providerSearchQueryByFacility.facilityTypeName,
          travelDistance: providerSearchQueryByFacility.travelDistance,
        },
      };
    case SET_PROVIDER_SEARCH_QUERY_BY_PROVIDER:
      const { providerSearchQueryByProvider } = action;
      return {
        ...state,
        providerSearchQueryByProvider: {
          state: providerSearchQueryByProvider.state,
          providerName: providerSearchQueryByProvider.searchText,
        },
      };
    case SET_PROVIDER_NAME_PREDICTION:
      return { ...state, predictedProviderNames: [...action.payload] };
    case SET_CPT_CODE_SUGGESTION:
      return { ...state, cptCodeSuggestion: [...action.payload] };
    case SET_PROVIDER_API_CALL_COUNT_BY_CLIENT:
      return {
        ...state,
        providerApiAnalyticsByClient: {
          ...action.providerApiCallCountByClient,
        },
      };

    case SET_USERS_ACTIVITY:
      return { ...state, usersActivity: [...action.payload] };
    case SET_SEARCH_DISTANCE:
      return { ...state, providerSearchDistance: action.payload };
    case SET_PROVIDER_COMMENT:
      return { ...state, providerComment: { ...action.payload } };

    case SET_ADD_PROVIDER_COMMENT:
      return { ...state, addedComment: { ...action.payload } };

    case SET_ADD_CLAIM:
      return { ...state, addedClaim: { ...action.payload } };

    case SET_ADD_PROVIDER_LIKE_FEEDBACK:
      return { ...state, addedLikeFeedback: { ...action.payload } };
    case SET_AI_SEARCH_RESULT:
      return { ...state, backgroundResearchData: { ...action.payload } };
    default:
      return state;
  }
};
